// Sync with blade template: document.blade.js
app.fileExtensions = {
		// Images
		'jpg': 'image',
		'jpeg': 'image',
		'png': 'image',
		'webp': 'image',
		'tiff': 'image',
		'bmp': 'image',
		'gif': 'image',
		'heic': 'image',
		'svg': 'image',

		// Video
		'mp4': 'video',
		'mov': 'video',
		'avi': 'video',
		'flv': 'video',
		'mkv': 'video',
		'wmv': 'video',
		'avchd': 'video',
		'webm': 'video',
		'gif': 'video',

		// Audio
		'pcm': 'audio',
		'wav': 'audio',
		'aiff': 'audio',
		'mp3': 'audio',
		'aac': 'audio',
		'ogg': 'audio',
		'wma': 'audio',

		// Text
		'txt': 'text',
		'ftf': 'text',

		// Word
		'doc': 'word',
		'docm': 'word',
		'docx': 'word',
		'dot': 'word',
		'dotm': 'word',
		'dotx': 'word',
		'odt': 'word',

		// Excel
		'xls': 'excel',
		'xlsm': 'excel',
		'xlsx': 'excel',
		'xlt': 'excel',
		'xltm': 'excel',
		'xltx': 'excel',
		'xml': 'excel',
		'ods': 'excel',
		'csv': 'excel',

		// Compressed
		'zip': 'compressed',
		'gzip': 'compressed',
		'gz': 'compressed',
		'rar': 'compressed',

		// PDF
		'pdf': 'pdf',
}

function getFileExtensionImage(filename) {
	var fileExtension = filename.split('.').pop().toLowerCase();
  return '/img/icons/files/' + (app.fileExtensions[fileExtension] ? app.fileExtensions[fileExtension] : 'blank') + '.svg';
}
